'use strict';

import _ from 'lodash';
import * as types from '../../types';
import actions from './actions';
import Cookie from 'js-cookie';
import lang from '../../../libs/lang';

let state = {
  imageName:                     null,
  isUploadingImage:              false,
  imageUploadingProgressPercent: 0,
  scannedDiscData:               null,
  scanError:                     null,
  discData:                      null,
  /*{
   name: 'オリジナル動画付き',
   //name: 'オリジナル動画付き缶バッジ特典動画',
   description: 'ザ・ラストヒーロー～ヘラクレスの掟～オリジナル動画付き缶バッジの特典動画です。缶バッジと同じメンバーの動画が見れます。',
   thumbnailUrl: '/static/img/tmp/disc_thumbnail.png',
   coverImageUrl: '/static/img/tmp/cover_image.png'
   },*/
  isSubmittingInquiry:           false,
  hasSignedCookie:               false,
  
  // コンテンツリストのスクロールポジション
  contentsListScrollPosition: 0,
  
  // アンケートに回答したか
  isFinishQuestionnaire: false,
  
  // ドキュメントダウンロード用に回答したか
  isFinishInputInfoDocumentDownload: false,
  
  // スナックバー
  snackBarBody: null
};

let mutations = {
  // カメラ画像アップロードする
  [types.UPLOAD_CAMERA_IMAGE](state){
    state.isUploadingImage = true;
  },
  
  // カメラ画像アップロードに成功した
  [types.UPLOAD_CAMERA_IMAGE_SUCCESS](state, {fileName}){
    state.imageName        = fileName;
    state.isUploadingImage = false;
  },
  
  // カメラ画像アップロードに失敗した
  [types.UPLOAD_CAMERA_IMAGE_FAILURE](state){
    state.isUploadingImage = false;
  },
  
  // LINEコンテンツゲットする
  [types.GET_LINE_CONTENTS](state, {data}){
  
  },
  
  // LINEコンテンツゲット成功
  [types.GET_LINE_CONTENTS_SUCCESS](state, {discData}){
  
  },
  
  // LINEコンテンツゲット失敗
  [types.GET_LINE_CONTENTS_FAILURE](state){
  
  },
  
  // ディスクデータを受信できたら
  [types.RECEIVE_DISC_DATA](state, {discData}){
    state.scannedDiscData = discData;
    state.discData        = discData;
  },
  
  // S3にアップロードしているときのプログレス更新
  [types.CHANGE_UPLOADING_PROGRESS](state, {progressPercent}){
    state.imageUploadingProgressPercent = progressPercent;
  },
  
  // スキャン結果画面を表示するタイミングでデータをリセット
  [types.RESET_SCAN_DISC_DATA](state){
    state.imageName                     = null;
    state.imageUploadingProgressPercent = 0;
    state.scannedDiscData               = null;
    state.scanError                     = null;
    state.isFinishQuestionnaire         = false;
  },
  
  // スキャン失敗
  [types.RECEIVE_DISC_DATA_FAILURE](state, {data}){
    state.imageName                     = null;
    state.imageUploadingProgressPercent = 0;
    state.scannedDiscData               = null;
    
    // エラーメッセージ
    if(data && data.advices && _.isArray(data.advices) && data.advices.length > 0){
      state.scanError = _.map(data.advices, (advice)=>{
        return advice[lang.getLang()];
      });
    }
    else{
      state.scanError = [];
    }
  },
  
  // SignedCookieをゲットできた
  [types.GET_SIGNED_COOKIE_SUCCESS](state, {credentials}){
    // cookieに保存
    try{
      for(let cookieId in credentials){
        Cookie.set(cookieId, credentials[cookieId], {domain: '.' + process.env.D3_DOMAIN, secure: true});
        // Cookie.set(cookieId, credentials[cookieId], {domain: '.dddisc.com', secure: true});
      }
    }
    catch(err){
      logger('Can not set cookie', err);
    }
    
    // 表示しよう
    state.hasSignedCookie = true;
  },
  
  // SignedCookieをゲットできなかった
  [types.GET_SIGNED_COOKIE_FAILURE](state){
    state.hasSignedCookie = false;
  },
  
  // SignedCookieをリセットする
  [types.RESET_SIGNED_COOKIE](state){
    state.hasSignedCookie = false;
  },
  
  // 問い合わせ送信
  [types.SEND_INQUIRY](state){
    state.isSubmittingInquiry = true;
  },
  
  [types.SEND_INQUIRY_SUCCESS](state){
    state.isSubmittingInquiry = false;
  },
  
  [types.SEND_INQUIRY_FAILURE](state){
    state.isSubmittingInquiry = false;
  },
  
  // コンテンツ再生（再生ログ生成）
  [types.PLAY_CONTENT](state){
  
  },
  
  [types.PLAY_CONTENT_SUCCESS](state){
  
  },
  
  [types.PLAY_CONTENT_FAILURE](state){
  
  },
  
  // アンケート回答
  [types.SEND_ANSWER](state){
  
  },
  
  [types.SEND_ANSWER_SUCCESS](state){
    state.isFinishQuestionnaire = true;
  },
  
  [types.SEND_ANSWER_FAILURE](state){
  
  },
  
  // ドキュメントダウンロード回答
  [types.SEND_INFO_FOR_DOCUMENT_DOWNLOAD](state){
    state.isSubmittingInquiry = true;
  },
  
  [types.SEND_INFO_FOR_DOCUMENT_DOWNLOAD_SUCCESS](state){
    state.isSubmittingInquiry = false;
    state.isFinishInputInfoDocumentDownload = true;
  },
  
  [types.SEND_INFO_FOR_DOCUMENT_DOWNLOAD_FAILURE](sate){
    state.isSubmittingInquiry = false;
  },
  
  // コンテンツリストのスクロールポジションかわった
  [types.UPDATE_CONTENTS_LIST_SCROLL_POSITION](state, {position}){
    state.contentsListScrollPosition = position;
  },
  
  /**
   * スナックバーを表示する
   * @param state
   * @param body
   */
  [types.SHOW_SNACK_BAR]: function(state, {body}){
    state.snackBarBody = {
      time: new Date(),  // かならずstateが更新されるようにtimeをつける
      body: body
    };
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/d3/store.js